import { Box } from '@mui/material'
import FooterLogo from 'components/footer-logo'
import Header from 'components/header'
import SoonIcon from 'components/svg/soon'
import { ReactNode } from 'react'
import { useStyles } from './styles'

interface SoonProps {
  children?: ReactNode
}

const Soon = ({ children }: SoonProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.base}>
      <Header>{children}</Header>
      <Box className={classes.page}>
        <Box className={classes.root}>
          <Box className={classes.container}>
            <SoonIcon
              width={165}
              height={183}
            />
            <h1>Novidade a caminho!</h1>
            <p>Esta página será lançada em breve.</p>
          </Box>
        </Box>
      </Box>
      <FooterLogo />
    </Box>
  )
}

export default Soon
